import { lazy } from 'react';

const WebsiteAd = lazy(() => import('./website-ad'));

export { WebsiteAd };
